<template>
    <transition name="fade">
        <section
            v-show="display"
            ref="modal"
            class="fixed inset-0 w-screen hidden max-w-full h-screen overflow-y-auto no-scrollbar scrolling-touch z-50"
        >
            <!-- π ----
            // :: LIQUID BACKGROUND
            // : ---------------------------------- -->
            <liquid-background ref="liquid" @animated-in="this.liquidResponse"></liquid-background>

            <!-- π ----
            // :: CLOSE
            // : ---------------------------------- -->
            <div
                ref="close"
                class="fixed lg:absolute bottom-0 lg:bottom-auto lg:top-0 left-0 lg:left-auto right-0 flex justify-center opacity-0 invisible z-10"
            >
                <button
                    @click="animateOut()"
                    aria-label="Close Search Window"
                    class="flex items-center mx-auto lg:mr-10 lg:mt-10 mb-6 sm:mb-10 lg:mb-0"
                >
                    <div
                        class="w-4 lg:w-10 text-white lg:text-gray-600 lg:hover:text-gray-200 transition-colors duration-300 ease-in-out-quad"
                    >
                        <svg class="w-full stroke-current stroke-w-3" viewBox="0 0 36 36">
                            <path
                                d="M33.214 2.295L2.271 33.19m30.502-.493L2.713 2.637"
                                fill="none"
                                vector-effect="non-scaling-stroke"
                            />
                        </svg>
                    </div>

                    <div class="lg:hidden text-lg leading-none ml-4">
                        Tap to Exit
                    </div>
                </button>
            </div>

            <!-- π ----
            // :: SLOT
            // : ---------------------------------- -->
            <div ref="content" class="relative container c-pad h-full opacity-0 lg:pt-24">
                <slot></slot>
            </div>
        </section>
    </transition>
</template>

<script>
import liquidBackground from '../components/liquid-background.vue';

export default {
    components: {
        liquidBackground
    },

    props: {
        display: {
            required: true,
            type: Boolean
        }
    },

    data() {
        return {
            isAnimating: false,
            isOpen: false
        };
    },

    watch: {
        display(value) {
            if (value) {
                this.open();
                document.querySelector('html, body').classList.add('overflow-hidden');
            } else {
                document.querySelector('html, body').classList.remove('overflow-hidden');
            }
        }
    },

    methods: {
        open() {
            this.$refs.modal.classList.remove('hidden');
            document.addEventListener('keyup', this.escapeClose);

            this.isOpen = true;
            this.$refs.liquid.toggle();
        },

        liquidResponse() {
            if (this.isOpen) {
                this.animateIn();
            } else {
                this.$refs.modal.classList.add('hidden');
                document.removeEventListener('keyup', this.escapeClose);
                document.querySelector('html, body').classList.remove('overflow-hidden');
                this.$emit('close');
            }
        },

        animateIn() {
            /* :: Set the Stage
            {+} ---------------------------------- */
            this.$refs.close.classList.remove('invisible');

            const animate = greensock.timeline();

            animate
                .to(this.$refs.content, {
                    opacity: 1,
                    duration: 0.64,
                    ease: 'power1.out'
                })
                .to(this.$refs.close, {
                    opacity: 1,
                    duration: 0.4,
                    ease: 'power1.out'
                });
        },

        animateOut() {
            if (!this.isAnimating) {
                this.isAnimating = true;

                const animate = greensock.timeline();

                animate
                    .to(this.$refs.content, {
                        opacity: 0,
                        duration: 0.4,
                        ease: 'power1.out'
                    })
                    .to(this.$refs.close, {
                        opacity: 0,
                        duration: 0.4,
                        ease: 'power1.out',
                        onComplete: () => {
                            /* :: Reset the Stage
                        {+} ---------------------------------- */
                            this.$refs.close.classList.add('invisible');

                            this.isOpen = false;
                            this.$refs.liquid.toggle();
                            this.isAnimating = false;
                        }
                    });
            }
        },

        escapeClose(event) {
            if (event.keyCode === 27) {
                this.animateOut();
            }
        }
    }
};
</script>
